import {
  productRouteSlug
} from "./chunk-OENSNHCR.js";

// src/product-ref.ts
function productRefKey(ref) {
  return ref.customIndex !== void 0 ? `${ref.product}:${ref.customIndex}` : ref.product;
}
function productRefsEqual(a, b) {
  return a.product === b.product && (a.customIndex ?? -1) === (b.customIndex ?? -1);
}
function isProductRefHidden(ref, hiddenProducts) {
  return hiddenProducts.some((entry) => productRefsEqual(entry, ref));
}
function effectiveStartupProduct(startupProduct) {
  return startupProduct ?? { product: "exxat-prism" };
}
function isStartupProductRef(ref, startupProduct) {
  return productRefsEqual(ref, effectiveStartupProduct(startupProduct));
}
function startupDashboardPath(startupProduct, customProducts = []) {
  const ref = effectiveStartupProduct(startupProduct);
  const customIndex = ref.customIndex ?? 0;
  const slug = productRouteSlug(ref.product, customProducts, customIndex);
  if (ref.product === "exxat-admin" || ref.product === "exxat-courses" || ref.product === "exxat-personnel") {
    return `/${slug}`;
  }
  if (ref.product === "exxat-people") {
    return `/${slug}/students`;
  }
  return `/${slug}/dashboard`;
}
function adjustProductRefAfterCustomRemoval(ref, removedIndex) {
  if (!ref || ref.product !== "exxat-custom") return ref;
  const idx = ref.customIndex ?? 0;
  if (idx === removedIndex) return null;
  if (idx > removedIndex) return { ...ref, customIndex: idx - 1 };
  return ref;
}
function adjustHiddenProductsAfterCustomRemoval(hidden, removedIndex) {
  return hidden.filter((entry) => !(entry.product === "exxat-custom" && entry.customIndex === removedIndex)).map((entry) => {
    if (entry.product === "exxat-custom" && entry.customIndex !== void 0 && entry.customIndex > removedIndex) {
      return { ...entry, customIndex: entry.customIndex - 1 };
    }
    return entry;
  });
}

export {
  productRefKey,
  productRefsEqual,
  isProductRefHidden,
  effectiveStartupProduct,
  isStartupProductRef,
  startupDashboardPath,
  adjustProductRefAfterCustomRemoval,
  adjustHiddenProductsAfterCustomRemoval
};
